// "Should I use THE CLAMPS!" ― Francis X. Clampazzo
export function clamp(value: number, max = 1, min = 0) {
  return Math.max(min, Math.min(max, value));
}
